import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Zap } from 'lucide-react';
import './Portal.css';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

const features = [
  { icon: <CheckCircle size={15} />, label: 'No vendor lock-in' },
  { icon: <CheckCircle size={15} />, label: '24/7 Support included' },
  { icon: <CheckCircle size={15} />, label: 'ISO 27001 certified' },
];

export default function Portal() {
  return (
    <section id="portal" className="cta-section">
      {/* Decorative background elements */}
      <div className="cta-orb cta-orb-1" />
      <div className="cta-orb cta-orb-2" />
      <div className="cta-grid-lines" />

      <motion.div
        className="container cta-content"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-80px' }}
      >
        {/* Badge */}
        <motion.div className="cta-badge" variants={fadeUp} custom={0}>
          <Zap size={12} />
          Trusted by 50+ Enterprises
        </motion.div>

        {/* Headline */}
        <motion.h2 variants={fadeUp} custom={1}>
          Ready to Elevate Your
          <br />
          <span className="gradient-text">Technology Stack?</span>
        </motion.h2>

        {/* Sub-copy */}
        <motion.p variants={fadeUp} custom={2}>
          Partner with Wayug Infotech to modernise your infrastructure, fortify
          your security posture, and accelerate digital transformation — all
          under one trusted roof.
        </motion.p>

        {/* Feature pills */}
        <motion.div className="cta-features" variants={fadeUp} custom={3}>
          {features.map((f) => (
            <div className="feature-item" key={f.label}>
              {f.icon}
              <span>{f.label}</span>
            </div>
          ))}
        </motion.div>

        {/* CTAs */}
        <motion.div className="cta-actions" variants={fadeUp} custom={4}>
          <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20schedule%20a%20consultation." target="_blank" rel="noopener noreferrer" className="btn btn-primary cta-btn-primary">
            Schedule a Consultation
          </a>
          <a href="https://wa.me/918287999236?text=Hi!%20I%20would%20like%20to%20explore%20your%20Managed%20Services." target="_blank" rel="noopener noreferrer" className="btn btn-outline cta-btn-outline">
            Explore Managed Services
          </a>
        </motion.div>

        {/* Trust line */}
        <motion.p className="cta-trust" variants={fadeUp} custom={5}>
          Join companies that have transformed with Wayug Infotech
        </motion.p>
      </motion.div>
    </section>
  );
}